import axios from "axios";

const actionCriarPedidoPagarme = (data) => {
    return axios({
        method: "post",
        //url: `http://localhost:4000/api/orders`,
         url: `https://payment-ktx.zindi.com.br/api/orders`,
        data: data
    });
};

export default actionCriarPedidoPagarme;





